<template>
  <section>
    <PageName title="Карты лояльности" :buttons="this.buttons" />

    <Preloader v-if="cardsLoading" />

    <VTable
        v-show="!cardsLoading"
        itemsType="array"
        :columns="cardsColumns"
        :items="mapedCards"
        :sortApi="sortCards"
        :selectedIndices="selectedIndices"
        @select="select"
        @row-click="openCard"
        selectable
        ref="table"
    />
  </section>
</template>

<script>
import {mapActions, mapState, mapGetters} from "vuex";
import {deleteCards} from "@/api/cards";
import { FIO } from "@/utils/filters/stringFilters";
import PageName from "@/components/PageName";
import Preloader from "@/components/Preloader";
import VTable from "@/components/Table/VTable";

export default {
  name: "Cards",
  components: {
    PageName,
    Preloader,
    VTable
  },

  data() {
    return {
      selectedCardsIds: [],
      cardsColumns: [
        { title: "№", sort: false, value: "id" },
        { title: "№ карты", sort: false, value: "card_number" },
        { title: "Пользователь", sort: false, value: "user.name" },
        { title: "Перевозчик", sort: false, value: "transporter" }
      ],
      paramsWidthSort: {
        page: 1,
        sort: 'id',
        search: '',
      },
      search: '',
      buttons: [
          {
            text: "Создать",
            icon: "addFile",
            event: this.create || {},
          },
          {
            text: "Удалить",
            icon: "delete",
            event: this.delete || {},
            iconWidth: "12px",
          }
        ]
      }
  },

  computed: {
    ...mapState("cards", ["cards", "cardsLoading"]),
    ...mapGetters('cards', ['getCardsListPagination']),

    mapedCards() {
      return this.cards?.map(card => {
        const userFIO = card.user && this.convertName(card.user);
        return [
          card.id,
          card.card_number || "-",
          userFIO,
          card.transporter || "-",
        ];
      });
    },
    selectedIndices: {
      get() {
        const indeces = [];

        this.cards.forEach((card, i) => {
          if (this.selectedCardsIds[card.id] !== undefined) {
            indeces.push(i);
          }
        });

        return indeces;
      },
      set(val) {
        const ids = [];
        for (let index = 0; index < val.length; index++) {
          const card = this.cards[val[index]];
          if (card?.id) ids[card.id] = card;
        }
        this.selectedCardsIds = ids;
      },
    },
  },

  methods: {
    ...mapActions("cards", ["getCards"]),

    openCard(num) {
      const node = this.cards[num - 1]
      this.$router.push({ name: 'SaveCardUpdate', params: { node, id_card: node.id } })
    },

    getPage (pageNum) {
      const params = {
        page: pageNum,
        sort: this.paramsWidthSort.sort,
        search: this.paramsWidthSort.search
      }
        this.$store.dispatch('cards/getCardsListPage', params)
    },

    sortCards(col, sort) {
      this.paramsWidthSort = {
        page: 1,
        sort: (sort ? "" : "-") + col?.value,
        search: this.paramsWidthSort.search
      }
      this.$store.dispatch('cards/getCardsListPage', this.paramsWidthSort)
    },

    select(value, index, all = null) {
      if (all !== null) {
        this.selectedIndices = all ? this.cards.map((el, i) => i) : [];
      } else if (value) {
        this.selectedIndices = [...this.selectedIndices, index];
      } else {
        this.selectedIndices = this.selectedIndices.filter((i) => i === index);
      }
    },

    delete() {
      if (this.selectedCardsIds.length) {
        const deleteCallback = async () => {
          this.selectedCardsIds.map(({ id }) => {
            deleteCards(id).finally(() => this.getCards())
          })
          this.selectedCardsIds = []
          this.$root.alert("Карты лояльности успешно удалены")
        }
        this.$root.confrim(
          "Вы уверены, что хотите удалить карты лояльности?",
          deleteCallback,
          "Да"
        );
      }
    },

    create() {
      this.$router.push({ name: 'SaveCardCreate' })
    },

    convertName(user) {
      const { name, surname, patronymic } = user;
      return FIO(name, surname, patronymic);
    }
  },

  destroyed () {
    this.$store.commit('cards/RESET_CARDS_LIST_CURRENT_PAGE')
  },

  watch: {
    search(val) {
      this.paramsWidthSort = {
        page: 1,
        sort: this.paramsWidthSort.sort,
        search: val
      }
      this.$store.dispatch('cards/getCardsListPage', this.paramsWidthSort)
    },
  },
}
</script>
